import { useTranslation } from "react-i18next";
import { useProjectParams } from "./projectContext";
import { useActivity } from "@/api/hooks/activity";
import { EmptyState } from "@/components/EmptyState";
import { ErrorNotice } from "@/components/ErrorNotice";
import { PageLoading } from "@/components/Spinner";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { formatDateTime, formatRelative } from "@/lib/dates";

export function ActivityPage() {
  const { t } = useTranslation();
  const { org, project } = useProjectParams();
  const activity = useActivity(org, project);

  if (activity.isPending) return <PageLoading />;
  if (activity.isError) return <ErrorNotice error={activity.error} />;
  const items = activity.data.pages.flatMap((p) => p.items);

  return (
    <section className="flex flex-col gap-4" aria-labelledby="activity-title">
      <div>
        <h2 id="activity-title" className="text-xl">
          {t("project.activityTitle")}
        </h2>
        <p className="text-fg-muted">{t("project.activityIntro")}</p>
      </div>
      {items.length === 0 ? (
        <EmptyState title={t("project.activityEmpty")} />
      ) : (
        <Card>
          <ol className="divide-y divide-border">
            {items.map((item) => (
              <li key={item.id} className="flex flex-col gap-1 px-6 py-4 sm:flex-row sm:items-baseline sm:justify-between sm:gap-6">
                <span>{item.sentence}</span>
                <time dateTime={item.created_at} title={formatDateTime(item.created_at)} className="shrink-0 text-sm text-fg-muted">
                  {formatRelative(item.created_at)}
                </time>
              </li>
            ))}
          </ol>
        </Card>
      )}
      {activity.hasNextPage ? (
        <div className="flex justify-center">
          <Button variant="secondary" onClick={() => void activity.fetchNextPage()} disabled={activity.isFetchingNextPage}>
            {activity.isFetchingNextPage ? t("project.loadingOlder") : t("project.showOlder")}
          </Button>
        </div>
      ) : null}
    </section>
  );
}
